import { FiLink, FiZap } from 'react-icons/fi';
import AuthButton from './AuthButton';

const Header = ({ user, onAuthChange }) => {
  return (
    <header className="bg-white shadow-sm border-b">
      <div className="container mx-auto px-4 py-6 max-w-6xl">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="p-2 bg-blue-500 rounded-lg">
              <FiLink className="h-6 w-6 text-white" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-gray-900">URL Shortener</h1>
              <p className="text-gray-600 text-sm">Make your links shorter and trackable</p>
            </div>
          </div>
          
          <div className="flex items-center gap-4">
            <AuthButton user={user} onAuthChange={onAuthChange} />
            <div className="hidden md:flex items-center space-x-2 text-sm text-gray-500">
              <FiZap className="h-4 w-4" />
              <span>Powered by Firebase</span>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header; 